<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Ürün {{ Object.entries(this.data).length === 0 ? "Ekle" : "Güncelle" }}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- Product Image -->
        <template v-if="formOptions.photo">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="formOptions.photo" alt="img" class="responsive" />
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*" />
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Foto Yükle</vs-button>
            <vs-button type="flat" color="#999" @click="formOptions.photo = null">Foto Kaldır</vs-button>
          </div>
        </template>

        <!-- NAME -->
        <vs-input label="Ürün Adı" v-model="formOptions.productName" class="mt-5 w-full" name="productName" danger-text="Zorunlu alan" :danger="!isFormValid && errors.has('productName')" v-validate="'required'" />
        <!-- desc -->
        <vs-textarea label="Açıklama" v-model="formOptions.productDescription" class="mt-5 w-full" name="productDescription" v-validate="'required'" danger-text="Zorunlu alan" :danger="!isFormValid && errors.has('productDescription')" />
        <!-- CATEGORY -->
        <label>Kategori</label>
        <v-select
          v-model="selectedCategory"
          placeholder="Kategori Seçiniz"
          class="w-full"
          name="productCategoryId"
          v-validate="'required'"
          :options="categories"
          label="categoryName"
          @input="formOptions.productCategoryId = selectedCategory.categoryId"
        >
          <span slot="no-options">Eşleşen Veri Yok</span>
        </v-select>
        <div v-show="!selectedCategory || !selectedCategory.categoryId" class="mb-5">
          <span class="text-danger text-sm">{{ errors.first("productCategoryId") }}</span>
        </div>
        <!-- invoice name -->
        <vs-input label="Fatura Adı" v-model="formOptions.invoiceName" class="mt-5 w-full" name="invoiceName" v-validate="'required'" danger-text="Zorunlu alan" :danger="!isFormValid && errors.has('invoiceName')" />
        <!-- brand name -->
        <vs-input label="Marka" v-model="formOptions.brand" class="mt-5 w-full" name="brand" v-validate="'required'" danger-text="Zorunlu alan" :danger="!isFormValid && errors.has('brand')" />
        <vs-input type="number" label="Ağırlık" v-model="formOptions.productWeight" class="mt-5 w-full" name="productWeight" :danger="!isFormValid && errors.has('productWeight')" />
        <vs-input label="Ürün Linki" v-model="formOptions.productLink" class="mt-5 w-full" name="productLink" :danger="!isFormValid && errors.has('productLink')" />
        <vs-input label="Min Fiyat" v-model="formOptions.minPrice" class="mt-5 w-full" name="minPrice" :danger="!isFormValid && errors.has('minPrice')" />
        <div class="mt-5 w-full">
        <label>Min Fiyat Döviz Türü</label>
        <v-select v-validate="'required'" name="currency"  placeholder="Min fiyat döviz türü" v-model="formOptions.minPriceCurrencyId" :options="currency" :clearable="false" :reduce="(currency) => currency.id" label="name">
          <span slot="no-options">Eşleşen Veri Yok</span>
        </v-select>
        </div>
        <vs-input label="Maliyet" v-model="formOptions.owningCost" class="mt-5 w-full" name="owningCost" :danger="!isFormValid && errors.has('owningCost')" />
        <div class="mt-5 w-full">
        <label>Maliyet Döviz Türü</label>
        <v-select v-validate="'required'" name="currency"  placeholder="Maaliyet döviz türü" v-model="formOptions.owningCostCurrencyId" :options="currency" :clearable="false" :reduce="(currency) => currency.id" label="name">
          <span slot="no-options">Eşleşen Veri Yok</span>
        </v-select>
        </div>
         <vs-input label="Satış Fiyatı" v-model="formOptions.salePrice" class="mt-5 w-full" name="salePrice" :danger="!isFormValid && errors.has('salePrice')" />

          <div class="mt-5 w-full">
        <label>Satış Fiyatı Döviz Türü</label>
        <v-select v-validate="'required'" name="currency"  placeholder="Satış döviz türü" v-model="formOptions.salePriceCurrencyId" :options="currency" :clearable="false" :reduce="(currency) => currency.id" label="name">
          <span slot="no-options">Eşleşen Veri Yok</span>
        </v-select>
        </div>
        
        <!--********* İnput alanı radiobutton  ile değiştirilecek yeni güncellemeler yapılacak ****************-->

        <div class="mt-2 flex items-center justify-between vx-row">
          <div class="vx-col md:w-1/3">
            <label>Tür :</label>
          </div>
          <div class="vx-col md:w-1/3">
            <vs-radio class="mt-5" v-model="formOptions.productType" vs-value="Hardware">Hardware</vs-radio>
          </div>
          <div class="vx-col md:w-1/3">
            <vs-radio class="mt-5" v-model="formOptions.productType" vs-value="Software">Software</vs-radio>
          </div>
          <!-- 

          <vs-radio  class="mt-5 ml-2" v-model="formOptions.productType" vs-value="Hardware">Hardware</vs-radio>
          <vs-radio  class="mt-5 ml-2" v-model="formOptions.productType" vs-value="Software">Software</vs-radio> -->
        </div>

        <!--*******************-->
        <!-- 
  
        

        <vs-input type="text" label="Tür" v-model="formOptions.productType" class="mt-5 w-full" name="productType" :danger="!isFormValid && errors.has('productType')" /> -->
        <!-- Parasut ID 
        <vs-input
          label="Parasut ID"
          v-model="formOptions.parasutId"
          class="mt-5 w-full"
          name="parasutId"
          v-validate="'required|numeric'"
        />
        <span class="text-danger text-sm" v-show="errors.has('parasutId')">{{
          errors.first("parasutId")
        }}</span>
        -->
        <div class="mt-2 flex items-center justify-between vx-row">
          <div class="vx-col w-1/2">
            <label class="mr-2 mt-5">Serinolu:</label>
          </div>

          <div class="vx-col w-1/2">
            <input class="ml-5" type="radio" name="forceBarcode" id="selectedPriceType1" v-validate="'required'" v-model="formOptions.forceBarcode" value="true" />
            <label for="selectedPriceType1">Evet</label>

            <input class="ml-5" type="radio" v-validate="'required'" id="selectedPriceType2" name="forceBarcode" v-model="formOptions.forceBarcode" value="false" />
            <label for="selectedPriceType2">Hayır</label>
          </div>
          <div v-show="!isFormValid && errors.has('forceBarcode')" class="mb-5">
            <span class="text-danger text-sm">{{ errors.first("forceBarcode") }}</span>
          </div>
        </div>

        <div class="mt-2 flex items-center justify-between vx-row">
          <div class="vx-col w-1/2">
            <label class="mr-2">Abonelik:</label>
          </div>

          <div class="vx-col w-1/2">
            <input class="ml-5" type="radio" name="requiresSubscription" id="requiresSubscription1" v-validate="'required'" v-model="formOptions.requiresSubscription" value="true" />
            <label for="requiresSubscription1">Evet</label>

            <input class="ml-5" type="radio" v-validate="'required'" id="requiresSubscription2" name="requiresSubscription" v-model="formOptions.requiresSubscription" value="false" />
            <label for="requiresSubscription2">Hayır</label>
          </div>
          <div v-show="!isFormValid && errors.has('requiresSubscription')" class="mb-5">
            <span class="text-danger text-sm">{{ errors.first("requiresSubscription") }}</span>
          </div>
        </div>

        <div class="mt-2 flex items-center justify-between vx-row">
          <div class="vx-col w-1/2">
            <label class="mr-2">Online Teslimat:</label>
          </div>

          <div class="vx-col w-1/2">
            <input class="ml-5" type="radio" name="onlineDelivery" id="onlineDelivery1" v-validate="'required'" v-model="formOptions.onlineDelivery" value="true" />
            <label for="onlineDelivery1">Evet</label>

            <input class="ml-5" type="radio" v-validate="'required'" id="onlineDelivery2" name="onlineDelivery" v-model="formOptions.onlineDelivery" value="false" />
            <label for="onlineDelivery2">Hayır</label>
          </div>
          <div v-show="!isFormValid && errors.has('onlineDelivery')" class="mb-5">
            <span class="text-danger text-sm">{{ errors.first("onlineDelivery") }}</span>
          </div>
        </div>

        <!-- <div class="upload-img mt-5" v-if="!formOptions.photo">
          <input
            type="file"
            class="hidden"
            ref="uploadImgInput"
            @change="updateCurrImg"
            accept="image/*"
          />
          <vs-button @click="$refs.uploadImgInput.click()"
            >Foto Yükle</vs-button
          >
        </div>-->
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <!-- <vs-button type="filled" @click="testAll">Text</vs-button> -->
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || !isChanged">Kaydet</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">İptal</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { Validator } from "vee-validate";
import { repository } from "@/_services/repository.js";
const dict = {
  custom: {
    productName: {
      required: "Zorunlu alan",
    },
    productDescription: {
      required: "Zorunlu alan",
    },
    productCategoryId: {
      required: "Zorunlu alan",
    },
    invoiceName: {
      required: "Zorunlu alan",
    },
    brand: {
      required: "Zorunlu alan",
    },
    parasutId: {
      required: "Zorunlu alan",
      numeric: "Sadece rakamlardan oluşabilir!",
    },
    forceBarcode: {
      required: "Zorunlu alan",
    },

    requiresSubscription: {
      required: "Zorunlu alan",
    },

    onlineDelivery: {
      required: "Zorunlu alan",
    },
  },
};
Validator.localize("tr", dict);

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Array,
      default: () => {},
    },
    value: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      selectedCategory: {
        categoryId: Number,
        categoryName: "",
      },
      currency: [],
      formOptions: {
        productName: "",
        productDescription: "",
        productCategoryId: "",
        invoiceName: "",
        brand: "",
        parasutId: "",
        forceBarcode: "",
        requiresSubscription: "",
        onlineDelivery: "",
        photo: "",
        productWeight: "",
        productLink: "",
        minPrice: "",
        minPriceCurrencyId:"",
        owninCost:"",
        owningCostCurrencyId:"",
        salePrice:"",
        salePriceCurrencyId:"",
        productType: "",
      },

      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },

  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.$validator.reset();
          this.initValues();
        }
      },
    },
    isChanged() {
      return (
        this.formOptions.productName !== this.data.productName ||
        this.formOptions.productDescription !== this.data.productDescription ||
        this.formOptions.productCategoryId !== this.selectedCategory.categoryId ||
        this.formOptions.invoiceName !== this.data.invoiceName ||
        this.formOptions.brand !== this.data.brand ||
        this.formOptions.forceBarcode !== this.data.forceBarcode ||
        this.formOptions.onlineDelivery !== this.data.onlineDelivery ||
        this.formOptions.requiresSubscription !== this.data.requiresSubscription ||
        this.formOptions.productWeight !== this.data.productWeight ||
        this.formOptions.productLink !== this.data.produtcLink ||
        this.formOptions.productType !== this.data.productType ||
        this.formOptions.minPrice !== this.data.minPrice ||
        this.formOptions.minPriceCurrencyId !== this.data.minPriceCurrencyId ||
        this.formOptions.owningCost !== this.data.owninCost ||
        this.formOptions.owningCostCurrencyId !== this.data.owningCostCurrencyId ||
        this.formOptions.salePrice !== this.data.salePrice ||
        this.formOptions.salePriceCurrencyId !==this.data.salePriceCurrencyId
      );
    },
    isFormValid() {
      return !this.errors.any() && this.formOptions.forceBarcode !== "" && this.formOptions.requiresSubscription !== "" && this.formOptions.onlineDelivery !== "";
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.selectedCategory = null;
        this.$validator.reset();
      } else {
        this.formOptions = JSON.parse(JSON.stringify(this.data));
        if (!this.formOptions.invoiceName) this.formOptions.invoiceName = "";
      
        this.selectedCategory = this.categories.find((x) => x.categoryId == this.formOptions.productCategoryId);
      }
      let a = this.isFormValid;
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
  },
  created() {
    this.getCurrencies();
  },
  methods: {
    // testAll: async function () {
    //   let c = await this.$validator.validateAll();
    //   console.log("selectedCategory", this.selectedCategory);
    //   console.log("data", this.data);
    //   console.log({
    //     isChanged: this.isChanged,
    //     "this.$validator.validateAll": c,
    //     "this.errors.any()": this.errors.any(),
    //     "this.formOptions": this.formOptions,
    //     "this.formOptions.forceBarcode": this.formOptions.forceBarcode !== "",
    //     "this.formOptions.requiresSubscription": this.formOptions.requiresSubscription !== "",
    //     "this.formOptions.onlineDelivery": this.formOptions.onlineDelivery !== "",
    //   });
    // },
 
    initValues() {
      this.formOptions = {
        productName: "",
        productDescription: "",
        productCategoryId: null,
        invoiceName: "",
        brand: "",
        parasutId: "",
        forceBarcode: "",
        requiresSubscription: "",
        onlineDelivery: "",
        photo: "",
        productWeight: "",
        productLink: "",
        productType: "",
        minPrice: "",
        minPriceCurrencyId:"",
        owningCost:"",
        owningCostCurrencyId:"",
        salePrice:"",
        salePriceCurrencyId:"",
        currency:[]
      };
    },
    submitData: async function () {
      //if(this.formOptions.forceBarcode == "1")this.formOptions.forceBarcode = true
      let control = await this.$validator.validateAll();
      if (control) {
        let r = null;
        if (this.data && this.data.productId > 0) {
          r = await repository.postEntity("Product/editProduct", this.formOptions);
        } else {
          r = await repository.postEntity("Product/createProduct", this.formOptions);
        }
        if (r && r.isSuccessful) {
          this.$vs.notify({
            title: "Başarılı",
            text: "Ürün kaydedildi",
            color: "success",
          });
          this.$emit("closeSidebar");
          this.initValues();
        } else {
          this.$vs.notify({
            title: "Hata ",
            text: (r.exceptionMessage && `${r.exceptionMessage} `) || "Bağlantı hatası",
            color: "danger",
            fixed: true,
          });
        }
      }
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.formOptions.photo = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    getCurrencies: async function () {
      this.currency = await repository.getAll("Accounting/getCurrencies").then((r) => r.list);
    },
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
